<template>
  <el-dialog
    v-if="visible"
    width="945px"
    show-close
    append-to-body
    :visible="visible"
    :title="displayTitle"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :before-close="() => close()"
    v-el-dialog-drag
  >
    <template #title>
      <div>
        <span class="el-dialog__title">
          {{ displayTitle }}
        </span>

        <el-button type="text" class="ml-4 py-0" @click="$refs.main.upload()">
          {{ $l('INDEX.btn_uploadAwsSkuImage') || '上传图片' }}
        </el-button>
      </div>
    </template>

    <Main
      ref="main"
      :amzSkuCode="amzSkuCode"
      @check="(t) => $emit('check', t)"
      @close="close()"
      @reload="$emit('reload')"
    />
  </el-dialog>
</template>

<script>
import Main from './main.vue'
export default {
  components: { Main },
  props: {
    visible: { type: Boolean, default: false },
    title: { type: String, default: '' },
    amzSkuCode: { type: String, default: '' },
  },
  computed: {
    displayTitle() {
      return (
        this.title ||
        this.$l('INDEX.dialog_title_editAwsSkuImage') ||
        '编辑产品图片'
      )
    },
  },
  methods: {
    close() {
      this.$emit('update:visible', false)
      this.$emit('close')
    },
  },
}
</script>

<style lang="scss" scoped></style>
